import { useContext } from 'react';
import { DraftEntityTypes } from '../../constants/Draft/DraftEntityTypes';
import { ContentState } from 'draft-js';
import { DraftLoadingContext } from './SmartDraftRenderer';
import styles from './FormDecorator.module.css';

export interface DecoratorComponentProps {
    children: JSX.Element;
    contentState: ContentState;
    entityKey: string;
    blockKey: string;
    start: number;
    end: number;
    editable?: boolean;
}

export function FormDecorator({
    children,
    entityKey,
}: DecoratorComponentProps): JSX.Element {
    const loading = useContext(DraftLoadingContext);

    return (
        <span
            id={entityKey}
            className={loading ? styles.loadingDecorator : styles.decorator}
            style={{
                overflow: 'hidden',
                position: 'relative',
                padding: '0px 3px',
                borderRadius: 12,
            }}
        >
            {children}
        </span>
    );
}

export function FormDecoratorsStrategy(
    contentBlock: any,
    callback: any,
    contentState: any
): void {
    contentBlock.findEntityRanges((character: any) => {
        const entityKey = character.getEntity();
        return (
            entityKey !== null &&
            contentState.getEntity(entityKey).getType() ===
                DraftEntityTypes.EUREKA
        );
    }, callback);
}
